import { render, staticRenderFns } from "./warning-user-list.vue?vue&type=template&id=2bcdc4a2&scoped=true&"
import script from "./warning-user-list.vue?vue&type=script&lang=js&"
export * from "./warning-user-list.vue?vue&type=script&lang=js&"
import style0 from "./warning-user-list.vue?vue&type=style&index=0&id=2bcdc4a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcdc4a2",
  null
  
)

export default component.exports